<div class="d-flex flex-column justify-content-start w-100 px-2 form-container">
  <div class="listing unit-list unit-list-height position-relative">
    <div class="item-list-container my-2">
      <ng-container
        *ngFor="let accessItem of userAccess | keyvalue; let i = index"
      >
        <h2 class="selected-access bold mt-4">
          <ng-container *ngIf="accessItem.key === CONSTANTS.HOME_ACCESS">
            {{ "HOME_ACCESS" | translate }}
          </ng-container>
          <ng-container
            *ngIf="
              accessItem.key === CONSTANTS.OTHER_ACCESS && commonAccessControl
            "
          >
            {{ "OTHER_ACCESS" | translate }}
          </ng-container>

          <ng-container *ngIf="accessItem.key === CONSTANTS.TEMPORARY_ACCESS">
            {{ "TEMPORARY_ACCESS" | translate }}
            <div class="d-flex flex-row align-items-center">
              <img
                class="mb-3"
                src="assets/svg/ico-vector-globe.svg"
                alt="Globe Icon"
              />
              <div
                class="col-8 pl-2 text-item d-flex flex-column justify-content-center"
              >
                <h5>
                  {{ siteTimeZone }}
                </h5>
              </div>
            </div>
          </ng-container>
        </h2>

        <ng-container *ngIf="accessItem?.value?.length < 1">
          <div class="group-container mb-1 mr-2">
            <div class="form-group rounded-top form-container">
              <div class="w-100 building-list-container">
                <div class="mr-2">
                  <div class="text-center">
                    {{ "NO_ACCCESS_TO_SHOW" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let accessObj of accessItem.value; let j = index">
          <div
            [ngClass]="{
              'w-100 px-3 py-2 filter-item':
                accessObj.entityType !== CONSTANTS.ACCESS_POINT ||
                commonAccessControl
            }"
            [class.first-child]="
              (j === 0 || accessItem.key === CONSTANTS.TEMPORARY_ACCESS) &&
              (accessObj.entityType !== CONSTANTS.ACCESS_POINT ||
                commonAccessControl)
            "
            [class.last-child]="
              j === accessItem.value?.length - 1 &&
              accessItem.key !== CONSTANTS.TEMPORARY_ACCESS
            "
            (click)="editAccess(accessObj)"
          >
            <div class="d-flex justify-content-center align-items-center">
              <span class="col-2 align-self-center">
                <img
                  *ngIf="
                    accessObj?.entityType === CONSTANTS.ENTITY_ACCESS_POINT &&
                    commonAccessControl
                  "
                  alt="User Icon"
                  src="assets/svg/ico-access-point-without-circle.svg"
                  class="setting-icon"
                />
                <img
                  *ngIf="accessObj?.entityType === CONSTANTS.LOCK"
                  alt="User Icon"
                  src="assets/svg/ico-lock.svg"
                  class="lock-icon"
                />
              </span>

              <ng-container
                *ngIf="
                  accessObj.entityType === CONSTANTS.ACCESS_POINT &&
                  commonAccessControl
                "
              >
                <div class="col-9">
                  <div class="col-12 bold heading3">
                    <app-profile-tooltip [showHelpCursor]="true">
                      {{ accessObj?.entityType + " " + accessObj?.entityName }}
                    </app-profile-tooltip>
                  </div>
                  <div class="col-12 status">
                    <app-profile-tooltip [showHelpCursor]="true">
                      {{
                        ("FLOOR" | translate) +
                          " " +
                          accessObj?.floorName +
                          ", " +
                          accessObj?.buildingName
                      }}
                      {{
                        userType === CONSTANTS.RESIDENT
                          ? ", " +
                            " -" +
                            (accessLevelResponse[accessObj.accessLevel]
                              | translate)
                          : ""
                      }}
                    </app-profile-tooltip>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="accessObj.entityType === CONSTANTS.LOCK">
                <div class="col-9">
                  <div class="col-12 bold heading3">
                    <app-profile-tooltip [showHelpCursor]="true">
                      {{ accessObj?.entityType + " " + accessObj?.entityName }}
                    </app-profile-tooltip>
                  </div>
                  <div class="col-12 status">
                    <app-profile-tooltip [showHelpCursor]="true">
                      {{
                        ("FLOOR" | translate) +
                          " " +
                          accessObj?.floorName +
                          ", " +
                          accessObj?.buildingName
                      }}
                      {{
                        userType === CONSTANTS.RESIDENT
                          ? ", " +
                            " -" +
                            (accessLevelResponse[accessObj.accessLevel]
                              | translate)
                          : ""
                      }}
                    </app-profile-tooltip>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  accessObj.entityType === CONSTANTS.ACCESS_POINT &&
                  commonAccessControl
                "
              >
                <span class="col-1 text-right align-self-center">
                  <span class="btn-not-text">
                    <div class="btn-list">
                      <button
                        mat-icon-button
                        type="button"
                        aria-label="phone"
                        (click)="editAccess(accessObj)"
                      >
                        <img src="assets/svg/ico-chevron-forward-outline.svg" />
                      </button>
                    </div>
                  </span>
                </span>
              </ng-container>

              <ng-container *ngIf="accessObj.entityType === CONSTANTS.LOCK">
                <span class="col-1 text-right align-self-center">
                  <span class="btn-not-text">
                    <div class="btn-list">
                      <button
                        mat-icon-button
                        type="button"
                        aria-label="phone"
                        (click)="editAccess(accessObj)"
                      >
                        <img src="assets/svg/ico-chevron-forward-outline.svg" />
                      </button>
                    </div>
                  </span>
                </span>
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="accessItem.key === CONSTANTS.TEMPORARY_ACCESS">
            <div
              [ngClass]="{
                'w-100 px-3 py-2 filter-item last-child':
                  accessObj.entityType !== CONSTANTS.ACCESS_POINT ||
                  commonAccessControl
              }"
            >
              <ng-container
                *ngIf="
                  accessObj.entityType === CONSTANTS.ACCESS_POINT &&
                  commonAccessControl
                "
              >
                <div class="d-flex justify-content-center align-items-center">
                  <span class="col-2 align-self-center">
                    <img
                      alt="User Icon"
                      src="assets/svg/ico-calendar-clear-outline.svg"
                      class="time-icon"
                    />
                  </span>
                  <ng-container
                    *ngIf="
                      accessObj.startTime && accessObj.expireTime;
                      else repeatAccess
                    "
                  >
                    <div class="col-10">
                      <div class="col-10 d-flex flex-row align-items-center">
                        <span class="bold heading3"
                          >{{ "STARTS" | translate }}:</span
                        >
                        <div
                          class="col-8 pl-1 text-item d-flex flex-column justify-content-center status"
                        >
                          <app-profile-tooltip [showHelpCursor]="true">
                            {{
                              accessObj.startTime
                                | parsedDateTime
                                  : "EEE, MMM do, yyyy 'at' h:mm a"
                            }}
                          </app-profile-tooltip>
                        </div>
                      </div>
                      <div class="col-10 d-flex flex-row align-items-center">
                        <span class="bold heading3"
                          >{{ "EXPIRES" | translate }}:</span
                        >
                        <div
                          class="col-8 pl-1 text-item d-flex flex-column justify-content-center status"
                        >
                          <app-profile-tooltip [showHelpCursor]="true">
                            {{
                              accessObj.expireTime
                                | parsedDateTime
                                  : "EEE, MMM do, yyyy 'at' h:mm a"
                            }}
                          </app-profile-tooltip>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #repeatAccess>
                    <div class="col-10">
                      <div class="pl-1 access-time max-height">
                        <span class="bold heading3">
                          {{ "ACCESS_TIME" | translate }}:
                        </span>

                        <span class="status">
                          <!-- <app-with-tooltip [showHelpCursor]="true"> -->
                          {{ accessObj?.repeatDays  | parsedDateTime : 'EEEE' : "EEEE" }}<span *ngIf="!last">, </span>
                          {{
                            accessObj?.repeatStartTime
                              | parsedTime : "HH:mm" : "hh:mm a"
                          }}

                          {{
                            "-" +
                              (accessObj?.repeatEndTime
                                | parsedTime : "HH:mm" : "hh:mm a")
                          }}
                          <!-- </app-with-tooltip> -->
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>

              <ng-container *ngIf="accessObj.entityType === CONSTANTS.LOCK">
                <div class="d-flex justify-content-center align-items-center">
                  <span class="col-2 align-self-center">
                    <img
                      alt="User Icon"
                      src="assets/svg/ico-calendar-clear-outline.svg"
                      class="time-icon"
                    />
                  </span>
                  <ng-container
                    *ngIf="
                      accessObj.startTime && accessObj.expireTime;
                      else repeatAccess
                    "
                  >
                    <div class="col-10">
                      <div class="col-12 d-flex flex-row align-items-center">
                        <span class="bold heading3"
                          >{{ "STARTS" | translate }}:</span
                        >
                        <div
                          class="col-9 pl-1 text-item d-flex flex-column justify-content-center status"
                        >
                          <app-profile-tooltip [showHelpCursor]="true">
                            {{
                              accessObj.startTime
                                | parsedDateTime
                                  : "EEE, MMM do, yyyy 'at' h:mm a"
                            }}
                          </app-profile-tooltip>
                        </div>
                      </div>
                      <div class="col-12 d-flex flex-row align-items-center">
                        <span class="bold heading3"
                          >{{ "EXPIRES" | translate }}:</span
                        >
                        <div
                          class="col-9 pl-1 text-item d-flex flex-column justify-content-center status"
                        >
                          <app-profile-tooltip [showHelpCursor]="true">
                            {{
                              accessObj.expireTime
                                | parsedDateTime
                                  : "EEE, MMM do, yyyy 'at' h:mm a"
                            }}
                          </app-profile-tooltip>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #repeatAccess>
                    <div class="col-10">
                      <div class="pl-1 access-time max-height">
                        <span class="bold heading3">
                          {{ "ACCESS_TIME" | translate }}:
                        </span>

                        <span class="status">
                          <!-- <app-with-tooltip [showHelpCursor]="true"> -->
                          {{ accessObj?.repeatDays | parsedDateTime : 'EEEE' : "EEEE" }}<span *ngIf="!last">, </span>
                          {{
                            accessObj?.repeatStartTime
                              | parsedTime : "HH:mm" : "hh:mm a"
                          }}

                          {{
                            "-" +
                              (accessObj?.repeatEndTime
                                | parsedTime : "HH:mm" : "hh:mm a")
                          }}
                          <!-- </app-with-tooltip> -->
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div class="blur-box"></div>
  </div>
</div>
